import { Box, Link as MuiLink, styled, Typography } from '@mui/material';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import { FC } from 'react';
import { Product } from '@acorn-portal/shared/src/services/interface/Shared';
import { getDocument } from '@acorn-portal/shared/src/utils';
import { addonDocumentEnums, genericDocumentEnums } from '@acorn-portal/shared/src/utils/constants';
import { FullPolicy, PolicyDocumentType } from '@acorn-portal/shared/src/services/api';

const StyledLink = styled(MuiLink)({
	textDecoration: 'none',
	py: 2,
	marginBottom: 10,
	display: 'flex',
	flexDirection: 'row',
	alignItems: 'center',
	'&:hover': {
		color: 'secondary.main',
		textDecoration: 'underline',
	},
});

interface IDocumentsSection {
	policy: FullPolicy;
	subscription?: boolean;
}

const DocumentsSection: FC<IDocumentsSection> = ({ policy: fullPolicy, subscription }) => {
	const policyBooklet = getDocument(
		fullPolicy.product,
		fullPolicy.isShortTermPolicy,
		PolicyDocumentType.POLICY_WORDING,
		subscription,
	);
	const ipid = getDocument(fullPolicy.product, fullPolicy.isShortTermPolicy, PolicyDocumentType.IPID, subscription);

	const ncbProtectionDocument = getDocument(
		fullPolicy.product,
		fullPolicy.isShortTermPolicy,
		addonDocumentEnums.NCB_PROTECTION,
	);

	const privacyPolicyDocument = getDocument(
		fullPolicy.product,
		fullPolicy.isShortTermPolicy,
		genericDocumentEnums.PRIVACY_POLICY,
	);

	const termsOfBusinessDocument = getDocument(
		fullPolicy.product,
		fullPolicy.isShortTermPolicy,
		genericDocumentEnums.TERMS_OF_BUSINESS,
	);

	return (
		<Box sx={{ mt: 4, minWidth: '50%', textAlign: 'left' }}>
			<Typography sx={{ fontWeight: 'bold' }}>View Your Documents</Typography>

			<Box
				sx={{
					display: 'flex',
					flexDirection: 'column',
					border: 2,
					borderColor: '#CFCFCF',
					p: 4,
					mt: 1,
					borderRadius: 3,
					minWidth: '50%',
					textAlign: 'left',
				}}
			>
				<StyledLink color='text.secondary' href={termsOfBusinessDocument} target='_blank' rel='noreferrer'>
					<PictureAsPdfIcon
						sx={(theme) => ({
							color: theme.palette.secondary.main,
							mr: 1,
						})}
					/>
					Terms of Business
				</StyledLink>
				<StyledLink color='text.secondary' href={policyBooklet} target='_blank' rel='noreferrer'>
					<PictureAsPdfIcon
						sx={(theme) => ({
							color: theme.palette.secondary.main,
							mr: 1,
						})}
					/>
					Policy Booklet
				</StyledLink>
				<StyledLink color='text.secondary' href={ipid} target='_blank' rel='noreferrer'>
					<PictureAsPdfIcon
						sx={(theme) => ({
							color: theme.palette.secondary.main,
							mr: 1,
						})}
					/>
					Insurance Product Information Document (IPID)
				</StyledLink>
				{fullPolicy.product !== Product.TAXI && (
					<StyledLink color='text.secondary' href={ncbProtectionDocument} target='_blank' rel='noreferrer'>
						<PictureAsPdfIcon
							sx={(theme) => ({
								color: theme.palette.secondary.main,
								mr: 1,
							})}
						/>{' '}
						No Claims Discount & Protection
					</StyledLink>
				)}
				<StyledLink color='text.secondary' href={privacyPolicyDocument} target='_blank' rel='noreferrer'>
					<PictureAsPdfIcon
						sx={(theme) => ({
							color: theme.palette.secondary.main,
							mr: 1,
						})}
					/>
					Privacy Policy
				</StyledLink>
			</Box>
		</Box>
	);
};

export default DocumentsSection;
